
var widgetURL = '';
var palette = [
    ["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)", /*"rgb(153, 153, 153)","rgb(183, 183, 183)",*/
    "rgb(204, 204, 204)", "rgb(217, 217, 217)", /*"rgb(239, 239, 239)", "rgb(243, 243, 243)",*/ "rgb(255, 255, 255)"],
    ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)",
    "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"],
    ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)",
    "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)",
    "rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)",
    "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)",
    "rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)",
    "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)",
    "rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)",
    "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)",
    /*"rgb(133, 32, 12)", "rgb(153, 0, 0)", "rgb(180, 95, 6)", "rgb(191, 144, 0)", "rgb(56, 118, 29)",
    "rgb(19, 79, 92)", "rgb(17, 85, 204)", "rgb(11, 83, 148)", "rgb(53, 28, 117)", "rgb(116, 27, 71)",*/
    "rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)",
    "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]
];

window.$("#backgroundColor").spectrum({
    allowEmpty:true,
    color: $("#bg_color").val(),
    showInput: true,
    containerClassName: "full-spectrum",
    showInitial: true,
    showPalette: true,
    showSelectionPalette: true,
    showAlpha: true,
    maxPaletteSize: 10,
    preferredFormat: "hex",
    localStorageKey: "spectrum.demo",
    move: function (color) {
        window.$("#backgroundColor").val(color);
        updatecolor(color);
    },
    show: function () {

    },
    beforeShow: function () {

    },
    hide: function (color) {
        window.$("#backgroundColor").val(color);
        //updatecolor(color);
    },

    palette: palette
});
window.$("#fontColor").spectrum({
    allowEmpty:true,
    color: $("#font_color").val(),
    showInput: true,
    containerClassName: "full-spectrum",
    showInitial: true,
    showPalette: true,
    showSelectionPalette: true,
    showAlpha: true,
    maxPaletteSize: 10,
    preferredFormat: "hex",
    localStorageKey: "spectrum.demo",
    move: function (color) {
        window.$("#fontColor").val(color);
        updatetextcolor(color);
    },
    show: function () {

    },
    beforeShow: function () {

    },
    hide: function (color) {
        window.$("#fontColor").val(color);
        //updatetextcolor(color);
    },

    palette: palette
});

window.$("#widgetbackgroundColor").spectrum({
    allowEmpty:true,
    color: $("#widget_bg_color").val(),
    showInput: true,
    containerClassName: "full-spectrum",
    showInitial: true,
    showPalette: true,
    showSelectionPalette: true,
    showAlpha: true,
    maxPaletteSize: 10,
    preferredFormat: "hex",
    localStorageKey: "spectrum.demo",
    move: function (color) {
        window.$("#widgetbackgroundColor").val(color);
        updatewidgetcolor(color);
    },
    show: function () {

    },
    beforeShow: function () {

    },
    hide: function (color) {
        //updatewidgetcolor(color);
    },

    palette: palette
});
window.$("#widgetfontColor").spectrum({
    allowEmpty:true,
    color: $("#widget_font_color").val(),
    showInput: true,
    containerClassName: "full-spectrum",
    showInitial: true,
    showPalette: true,
    showSelectionPalette: true,
    showAlpha: true,
    maxPaletteSize: 10,
    preferredFormat: "hex",
    localStorageKey: "spectrum.demo",
    move: function (color) {
        window.$("#widgetfontColor").val(color);
        updatewidgettextcolor(color);
    },
    show: function () {

    },
    beforeShow: function () {

    },
    hide: function (color) {
        //updatewidgettextcolor(color);
    },

    palette: palette
});

// WIDGET BUTTON COLOR
window.$("#widgetButtonBackgroundColor").spectrum({
    allowEmpty:true,
    color: $("#widget_btn_bg_color").val(),
    showInput: true,
    containerClassName: "full-spectrum",
    showInitial: true,
    showPalette: true,
    showSelectionPalette: true,
    showAlpha: true,
    maxPaletteSize: 10,
    preferredFormat: "hex",
    localStorageKey: "spectrum.demo",
    move: function (color) {
        window.$("#widgetButtonBackgroundColor").val(color);
        updatewidgetcolor(color);
    },
    show: function () {

    },
    beforeShow: function () {

    },
    hide: function (color) {
        //updatewidgetcolor(color);
    },

    palette: palette
});
window.$("#widgetButtonFontColor").spectrum({
    allowEmpty:true,
    color: $("#widget_btn_font_color").val(),
    showInput: true,
    containerClassName: "full-spectrum",
    showInitial: true,
    showPalette: true,
    showSelectionPalette: true,
    showAlpha: true,
    maxPaletteSize: 10,
    preferredFormat: "hex",
    localStorageKey: "spectrum.demo",
    move: function (color) {
        window.$("#widgetButtonFontColor").val(color);
        updatewidgetcolor(color);
    },
    show: function () {

    },
    beforeShow: function () {

    },
    hide: function (color) {
        //updatewidgetcolor(color);
    },

    palette: palette
});
window.$(".code_save").on('click',function(){
    $(this).attr('disabled',true)
    var widgetForm = $("#button_widget_form").serializeArray();
    var widgetFormarray = {};
    $.map(widgetForm, function(n, i){
        widgetFormarray[n['name']] = n['value'];
    });
    
    // AXIOS REQUEST
    window.axios({
        method: "post",
        url: window.$("#button_widget_form").attr('action'),
        data: {jsondata: widgetFormarray,restaurant_id:$("#merchantId").val(),widgettype:"button"}
    }).then(function (response) {
        $(".code_save").removeAttr('disabled')
        var responseData = response.data.data;
        var config = JSON.parse(response.config.data)['jsondata'];
        setConfigValue(config);
        window.toastr.success(response.data.message, "Successfully Saved");
    }).catch(function (error) {
        if (typeof error.response !== 'undefined') {
            var responseVal = '';
            if (error.response.status == 400) {
                window.toastr.error(responseVal, error.response.data.statusText);
                return false;
            }
            window.toastr.error(error.response.data.message, error.response.data.statusText);
        }
    });
});

window.$(".widget_code_save").on('click',function(){
    $(this).attr('disabled',true)
    var widgetForm = $("#widget_form").serializeArray();
    var widgetFormarray = {};
    $.map(widgetForm, function(n, i){
        widgetFormarray[n['name']] = n['value'];
    });
    console.log(widgetFormarray);
    // AXIOS REQUEST
    window.axios({
        method: "post",
        url: window.$("#widget_form").attr('action'),
        data: {jsondata: widgetFormarray,restaurant_id:$("#widget_merchantId").val(),widgettype:"widget"}
    }).then(function (response) {
        $(".widget_code_save").removeAttr('disabled')
        var responseData = response.data.data;
        var config = JSON.parse(response.config.data)['jsondata'];
        setConfigValue(config);
        window.toastr.success(response.data.message, "Successfully Saved");
    }).catch(function (error) {
        if (typeof error.response !== 'undefined') {
            var responseVal = '';
            if (error.response.status == 400) {
                window.toastr.error(responseVal, error.response.data.statusText);
                return false;
            }
            window.toastr.error(error.response.data.message, error.response.data.statusText);
        }
    });
});
function updatewidgetcolor(color){
    // $(".formCol,.formHeader").css({
    //     "background-color":color,
    // });
    widgetCodeGenerate();
}
function updatewidgettextcolor(color){
    $("#reservationForm,.fontcolor").css({
        color:color,
    })
    widgetCodeGenerate();
}
function setConfigValue(config){
    var buttonConfig = '';
    var widgetConfig = '';
    if(config){
        buttonConfig = config;
    }else{
        buttonConfig = ($("#button_json_config").val() ? JSON.parse($("#button_json_config").val()) : '');
        widgetConfig = ($("#widget_json_config").val() ? JSON.parse($("#widget_json_config").val()) : '');
    }
    // BUTTON CONFIG
    // $(".preview_btn,.actual_btn,.actual_nxt_btn").css('background',buttonConfig['backgroundColor']);
    // $(".preview_btn,.actual_btn,.actual_nxt_btn").css('color',buttonConfig['fontColor']);
    if($(".actual_btn").length > 0){
        if(buttonConfig['button_txt'] && buttonConfig['button_txt']!==undefined){
            $(".actual_btn")[0].innerHTML = buttonConfig['button_txt'];
        }else{
            $(".actual_btn")[0].innerHTML = 'Reserve Now';
        }
    }
    $(".preview_btn,.actual_btn,.actual_nxt_btn").each(function () {
        this.style.setProperty( 'background', buttonConfig['backgroundColor'], 'important' );
    });
    $(".preview_btn,.actual_btn,.actual_nxt_btn").each(function () {
        this.style.setProperty( 'color', buttonConfig['fontColor'], 'important' );
    });
    $(".preview_btn,.actual_btn").css({
        "font-size": buttonConfig['buttonSize']
     });
    if(buttonConfig['buttonshape'] == 'rounded'){
        $(".preview_btn,.actual_btn").each(function () {
            this.style.setProperty( 'border-radius', '5px', 'important' );
        });
    }else if(buttonConfig['buttonshape'] == 'not_rounded'){
        $(".preview_btn,.actual_btn").each(function () {
            this.style.setProperty( 'border-radius', '0px', 'important' );
        });
    }
    buttonStyleChange(buttonConfig['buttonPosition'], true);
    console.log(widgetConfig);
    //WIDGET CONFIG
    $("#reservationForm,.fontcolor").css({
        color:widgetConfig['widgetfontColor'],
    });
    // $(".formCol,.formHeader").css({
    //     "background-color":widgetConfig['widgetbackgroundColor'],
    // });
}

window.$(".widget_code_default").on('click',function(){
    $("#reservationForm,.fontcolor").css({
        color: '#0c343d',
    });
    $(".formCol,.formHeader").css({
        "background-color": '#F5F7F9'
    });
    $("#widget_font_color,#widgetfontColor").val('#0c343d');
    $("#widget_bg_color,#widgetbackgroundColor").val('#F5F7F9');
    $("#widgetfontColor").spectrum({
        color: "#0c343d"
    });
    $("#widgetbackgroundColor").spectrum({
        color: "#F5F7F9"
    });
    $( ".widget_code_save" ).trigger( "click" );
      
});

window.$(".button_code_default").on('click',function(){
    var defaultbgColor = "#0B55B1";
    var defaultfontcolor = "#FFFFFF";
    $("#bg_color,#backgroundColor").val(defaultbgColor);
    $("#font_color,#fontColor").val(defaultfontcolor);
    $(".preview_btn").css({
        "border-radius": "20px"
     });
     window.$(".preview_btn").css({
        "font-size": 'small'
     });
    $("#fontColor").spectrum({
        color: "#FFFFFF"
    });
    $("#backgroundColor").spectrum({
        color: "#0B55B1"
    });
    $("[name='buttonshape']").val('rounded');
    $("[name='buttonPosition']").val('center');
    $("[name='buttonSize']").val('small');
    $(".currentbuttoncard").css({
        "text-align": "center",
        "position": "absolute",
        "top": "30%",
        "right": "6%",
    });
    $(".actual_btn,.preview_btn").css({
        "width": "140px",
        "height": "40px",
        "background": "#0B55B1",
        "border-radius": "20px",
        "font-size": "14px",
        "color": "#fff"
    });
    $(".code_save").trigger("click");
});

function updatecolor(color){
    $( '.preview_btn' ).each(function () {
        this.style.setProperty( 'background', color, 'important' );
    });
    buttonCodeGenerate();
}

function updatetextcolor(color){
    $( '.preview_btn' ).each(function () {
        this.style.setProperty( 'color', color, 'important' );
    });
    buttonCodeGenerate();
}

function buttonCodeGenerate(loadSrc){
    var widgetForm = $("#widget_form").serializeArray();
    var buttonForm = $("#button_widget_form").serializeArray();
    var forbutton = {};
     var widgetAPI_URL   = widgetURL+"/index.js";

    $.map(buttonForm, function(n, i){
        forbutton[n['name']] = n['value'];
    });
    $.map(widgetForm, function(n, i){
        forbutton[n['name']] = n['value'];
    });
    var codeSnipperScript = {...forbutton};
    codeSnipperScript['theme'] = 'customer';
    var restaurant_id = $("#hidden_restaurantId").val();
    // if(loadSrc != 'isContentLoad'){
    //     if(!document.querySelector('script[name=widgetScript]') || document.querySelector('script[name=widgetScript]') === null){
            
    //     }else{
    //         document.querySelector('script[name=widgetScript]').remove();
    //     }
    //     setTimeout(function(){
    //         var d = document,sc = d.createElement('script');
    //         sc.src=widgetURL+"/index.js?render="+Math.random();
    //         sc.setAttribute('name','widgetScript');
    //         sc.setAttribute('id','widgetForm');
    //         sc.setAttribute('data-widgetconfig',JSON.stringify(forbutton))
    //         var scriptWrapper = d.getElementsByClassName('muru-widget-builder')[0];
    //         var tag = d.getElementsByTagName('script')[0];
    //         scriptWrapper.append(sc);
    //         // var tag = d.getElementsByTagName('script')[0];
    //         // tag.parentNode.insertBefore(sc,tag);
    //     },1200)  
    // }
    var codeSnippet = '';
    codeSnipperScript['render_button'] = 'no';
    codeSnippet = "&lt;div class='muru-widget-builder'&gt; &lt;script type='module' id='widgetForm' name='widgetScript' data-restaurantid='"+restaurant_id+"' data-src='widget' data-widgetconfig='"+ JSON.stringify(codeSnipperScript)+"' src='"+widgetAPI_URL+"'&gt;&lt;/script&gt;&lt;/div&gt;";
    $("#widgetcodeSnippet").html(codeSnippet);
    codeSnipperScript['render_button'] = 'yes';
    codeSnippet = "&lt;div class='muru-widget-builder'&gt; &lt;script type='module' id='widgetForm' name='widgetScript' data-restaurantid='"+restaurant_id+"' data-src='widget' data-widgetconfig='"+ JSON.stringify(codeSnipperScript)+"' src='"+widgetAPI_URL+"'&gt;&lt;/script&gt;&lt;/div&gt;";
    $("#codeSnippet").html(codeSnippet);
    
    
}

function widgetCodeGenerate(loadSrc){
    var widgetForm = $("#widget_form").serializeArray();
    var buttonForm = $("#button_widget_form").serializeArray();
    var restaurant_id = $("#hidden_restaurantId").val();
    var widgetFormarray = {};
    var widgetAPI_URL   = widgetURL+"/index.js";

    $.map(widgetForm, function(n, i){
        widgetFormarray[n['name']] = n['value'];
    });
    $.map(buttonForm, function(n, i){
        widgetFormarray[n['name']] = n['value'];
    });
    widgetFormarray['theme'] = 'admin';
    widgetFormarray['restaurant_id'] = restaurant_id;
    var codeSnippetScript = {...widgetFormarray};
    codeSnippetScript['theme'] = 'customer';
    codeSnippetScript['restaurant_id'] = restaurant_id;
    if(loadSrc != 'isContentLoad'){
        if(!document.querySelector('script[name=widgetScript]') || document.querySelector('script[name=widgetScript]') === null){
        }else{
            document.querySelector('script[name=widgetScript]').remove();
        }
        setTimeout(function(){
            var d = document,sc = d.createElement('script');
            sc.src=widgetURL+"/index.js?render="+Math.random();
            sc.setAttribute('name','widgetScript');
            sc.setAttribute('id','widgetForm');
            sc.setAttribute('data-widgetconfig',JSON.stringify(widgetFormarray))
            sc.setAttribute('data-src','admin')
            var scriptWrapper = d.getElementsByClassName('muru-widget-builder')[0];
            var tag = d.getElementsByTagName('script')[0];
            scriptWrapper.append(sc);
            //tag.parentNode.insertBefore(sc,tag);
        },1200)
    }
    var codeSnippet = '';
    codeSnippetScript['render_button'] = 'yes';
    var codeSnippet = "&lt;div class='muru-widget-builder'&gt;&lt;script  type='module' id='widgetForm' name='widgetScript' data-restaurantid='"+restaurant_id+"' data-src='widget' data-widgetconfig='"+ JSON.stringify(codeSnippetScript)+"' src='"+widgetAPI_URL+"'&gt;&lt;/script&gt;&lt;/div&gt;";
    $("#codeSnippet").html(codeSnippet);
    codeSnippetScript['render_button'] = 'no';
    var codeSnippet = "&lt;div class='muru-widget-builder'&gt;&lt;script  type='module' id='widgetForm' name='widgetScript' data-restaurantid='"+restaurant_id+"' data-src='widget' data-widgetconfig='"+ JSON.stringify(codeSnippetScript)+"' src='"+widgetAPI_URL+"'&gt;&lt;/script&gt;&lt;/div&gt;";
    $("#widgetcodeSnippet").html(codeSnippet);
    
}

document.addEventListener('DOMContentLoaded', function() {
    var adminWidget = document.getElementById('adminwidget');
    if(adminWidget){
       widgetURL = adminWidget.getAttribute('widget-url');
    }
    buttonCodeGenerate('isContentLoad');
    setConfigValue();
    widgetCodeGenerate('isContentLoad');
},false);

window.$(".widget_code_copy").on('click',function(){
    const copyText = document.getElementById("widgetcodeSnippet").textContent;
    const textArea = document.createElement('textarea');
    textArea.setAttribute("id", 'widgetcodesnippetarea');
    textArea.textContent = copyText;
    document.body.append(textArea);
    textArea.select();
    document.execCommand("copy");
    document.getElementById("widgetcodesnippetarea").remove();
    window.toastr.success('Copied');
});

window.$(".button_code_copy").on('click',function(){
    const copyText = document.getElementById("codeSnippet").textContent;
    const textArea = document.createElement('textarea');
    textArea.setAttribute("id", 'widgetcodesnippetarea');
    textArea.textContent = copyText;
    document.body.append(textArea);
    textArea.select();
    document.execCommand("copy");
    document.getElementById("widgetcodesnippetarea").remove();
    window.toastr.success('Copied');
});

window.$(".btn_style").on('change',function(){
    var styleName = $(this).attr('name');
    var styleValue = $(this).val();
    if(styleName == 'buttonshape'){
        if(styleValue == 'rounded'){
            $(".preview_btn").each(function () {
                this.style.setProperty( 'border-radius', '5px', 'important' );
            });
           
        }else if(styleValue == 'not_rounded'){
            $(".preview_btn").each(function () {
                this.style.setProperty( 'border-radius', '0px', 'important' );
            });
        }
    }else if(styleName == 'buttonPosition'){
        buttonStyleChange(styleValue);

    }else if(styleName == 'buttonSize'){
        window.$(".preview_btn").css({
            "font-size": styleValue
         });
    }
    buttonCodeGenerate();
});

function buttonStyleChange(styleValue,multiselector=false){
    var selector = '';

    if(multiselector){
        selector = window.$(".previewCard,.currentbuttoncard");
    }else{
        selector = window.$(".previewCard");
    }
    if(styleValue == 'top'){
        selector.css({
            "top": "0%",
            "left":"inherit",
            "right":"inherit",
         });
    }else if(styleValue == 'bottom'){
        selector.css({
            "top":"inherit",
            "bottom":"0%",
            "left":"inherit",
            "right":"18px",
         });
    }else if(styleValue == 'center'){
        selector.css({
            "top":"30%",
            "bottom":"inherit",
            "left":"inherit",
            "right":"20px",
         });
    }else if(styleValue == 'left'){
        selector.css({
            "left":"-5%",
            "bottom":"inherit",
            "right":"inherit",
            "top":"30%",
            
         });
    }else if(styleValue == 'right'){
        selector.css({
            "right":"-8%",
            "bottom":"inherit",
            "left":"inherit",
            "top":"30%",
            
         });
    }
}
// date and time picker
window.$("#reservationDate").datetimepicker({
    timepicker: false,
    format: DATE_FORMAT,
    step: 15,
    dayOfWeekStart: 1,
    onShow: function (ct) {
       
    },
    onChangeYear: function (dateText, inst) {
       
    },
    onChangeMonth: function (dateText, inst) {
       
    }
});
var buttonTxtId = document.getElementById('button_txt');
if(buttonTxtId){
buttonTxtId.onkeyup = function(){
    if(buttonTxtId.value){
        document.getElementById('prev-btn').innerHTML = buttonTxtId.value;
    }else{
        document.getElementById('prev-btn').innerHTML = 'Reserve Now';
    }
}
}



